export default __webpack_public_path__ + "static/media/BLOCKCHAIN_LOGO.1b81f32e.svg";